// Rebuy button on account page
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.rebuy_btn').forEach(button => {
    button.addEventListener('click', async function () {
      const variant_data = this.getAttribute('data-order-variants');
      
      // Convert variant_data into an array of objects
      const variant_dataObjArray = variant_data.split(",").map(str => {
        let strParts = str.split("_");
        if (strParts[0] && strParts[1]) {
          return {
            id: strParts[0].trim(),
            quantity: parseInt(strParts[1].trim())
          };
        }
      }).filter(item => item !== undefined); // Filter out any undefined items

      // Prepare items to be added to the cart
      const data = {
        items: variant_dataObjArray
      };

      console.log(data);

      // Add items to the cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(response => response.json())
      .then(data => {
        console.log('Products added:', data);
        window.location.href = '/cart';
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    });
  });
});
